/* eslint-disable */
// @ts-nocheck

import React from "react";
import { FormLabel, Checkbox } from "@carbon/react";
import FieldTooltip from "../tooltip/Tooltip";

interface IProps {
  id: string;
  labelText: string;
  onChange: (val: any) => void;
  checked: boolean;
  disabled?: boolean;
  invalid?: boolean;
  invalidText: string;
  required?: boolean;
  defaultChecked?: boolean;
  tooltipText?: string;
}
const CheckBox = ({
  id,
  labelText,
  onChange,
  defaultChecked = false,
  disabled = false,
  invalid,
  invalidText,
  required = false,
  tooltipText,
}: IProps) => {
  return (
    <>
      <div className="form-label" data-cy="textFieldForm">
        <FormLabel data-cy={`${labelText.replaceAll(" ", "")}-textlabel`}>
          <Checkbox
            labelText={required === true ? `${labelText} *` : labelText}
            id={id}
            disabled={disabled}
            invalid={invalid}
            invalidText={invalidText}
            defaultChecked={defaultChecked}
            onChange={onChange}
          />
        </FormLabel>
        {tooltipText ? (
          <FieldTooltip
            label={tooltipText}
            fieldName={`${labelText.replaceAll(" ", "")}-`}
          />
        ) : null}
      </div>
    </>
  );
};

export default CheckBox;
